import moment from 'moment';
import { AccountData, OrderData } from '../api';
import { formatSeconds } from '../calendar/agendaView/utils/areasFormat';
import { priceFormatterFromCurrency } from '../utils/utils';

export const getOrderName = (order: OrderData) => [order.firstname, order.lastname].filter(Boolean).join(' ');

export const getItemsTotal = (order: OrderData) =>
  (order.extra_items ?? []).reduce((total, item) => total + item.unit_price * item.quantity, 0);

export const getOrderCalendarPath = (order: OrderData) =>
  `/dashboard/calendar/${order.date}?entityid=${order.parent_id || order.id}`;

export const formatBillAmount = (amount: number, account: AccountData) =>
  priceFormatterFromCurrency(amount, account.currency, undefined, false, false);

export const formatBillDateTime = (order: OrderData, shortDateFormat: string, timeFormat: string) => {
  const date = moment(order.date);
  return `${date.format('ddd')} ${date.format(shortDateFormat)} · ${formatSeconds(order.time ?? 0, timeFormat)}`;
};
